import React from 'react';

const lnerPlayStoreUrl =
  'https://play.google.com/store/apps/details?id=uk.co.icectoc.customer';

const GooglePlayButton: React.FC = () => (
  <a
    id="googlePlayButton"
    href={lnerPlayStoreUrl}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Link to Google Play Store"
  >
    <svg
      width="8.5rem"
      height="3rem"
      viewBox="0 0 135 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      css={{ minWidth: '136px', minHeight: '48px' }}
    >
      <title>Google Play Badge</title>
      <defs>
        <linearGradient
          x1="61.0265807%"
          y1="4.94692737%"
          x2="26.4999303%"
          y2="71.9158021%"
          id="linearGradient-1"
        >
          <stop stopColor="#00A0FF" offset="0%"></stop>
          <stop stopColor="#00A1FF" offset="0.657445%"></stop>
          <stop stopColor="#00BEFF" offset="26.01%"></stop>
          <stop stopColor="#00D2FF" offset="51.22%"></stop>
          <stop stopColor="#00DFFF" offset="76.04%"></stop>
          <stop stopColor="#00E3FF" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="107.622047%"
          y1="50.0163551%"
          x2="-130.536417%"
          y2="50.0163551%"
          id="linearGradient-2"
        >
          <stop stopColor="#FFE000" offset="0%"></stop>
          <stop stopColor="#FFBD00" offset="40.87%"></stop>
          <stop stopColor="#FFA500" offset="77.54%"></stop>
          <stop stopColor="#FF9C00" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="86.2529976%"
          y1="30.8965558%"
          x2="-50.1876499%"
          y2="136.080795%"
          id="linearGradient-3"
        >
          <stop stopColor="#FF3A44" offset="0%"></stop>
          <stop stopColor="#C31162" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="-18.7699221%"
          y1="-11.8318633%"
          x2="42.1204314%"
          y2="35.08088%"
          id="linearGradient-4"
        >
          <stop stopColor="#32A071" offset="0%"></stop>
          <stop stopColor="#2DA771" offset="6.85%"></stop>
          <stop stopColor="#15CF74" offset="47.62%"></stop>
          <stop stopColor="#06E775" offset="80.09%"></stop>
          <stop stopColor="#00F076" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Shared-(Intern)"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="LM-2582-Webpage---Shared-Desktop---Return"
          transform="translate(-537.000000, -736.000000)"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(401.000000, 108.000000)">
            <g id="Group-11" transform="translate(0.000000, 596.000000)">
              <g id="Group-9" transform="translate(0.000000, 32.000000)">
                <g
                  id="google-play-badge"
                  transform="translate(136.000000, 0.000000)"
                >
                  <path
                    d="M130,40 L5,40 C2.25,40 0,37.75 0,35 L0,5 C0,2.25 2.25,0 5,0 L130,0 C132.75,0 135,2.25 135,5 L135,35 C135,37.75 132.75,40 130,40 Z"
                    id="Path"
                    fill="#000000"
                  ></path>
                  <path
                    d="M130,0.8 C132.32,0.8 134.2,2.68 134.2,5 L134.2,35 C134.2,37.32 132.32,39.2 130,39.2 L5,39.2 C2.68,39.2 0.8,37.32 0.8,35 L0.8,5 C0.8,2.68 2.68,0.8 5,0.8 L130,0.8 M130,0 L5,0 C2.25,0 0,2.25 0,5 L0,35 C0,37.75 2.25,40 5,40 L130,40 C132.75,40 135,37.75 135,35 L135,5 C135,2.25 132.75,0 130,0 L130,0 Z"
                    id="Shape"
                    fill="#A6A6A6"
                  ></path>
                  <g
                    id="Group"
                    transform="translate(41.000000, 6.000000)"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth="0.2"
                  >
                    <path
                      d="M6.42,4.24 C6.42,5.08 6.17,5.75 5.67,6.24 C5.11,6.83 4.37,7.13 3.47,7.13 C2.6,7.13 1.87,6.83 1.26,6.23 C0.65,5.63 0.35,4.88 0.35,4 C0.35,3.11 0.65,2.37 1.26,1.77 C1.87,1.17 2.6,0.87 3.47,0.87 C3.9,0.87 4.31,0.95 4.7,1.12 C5.09,1.29 5.4,1.51 5.64,1.79 L5.11,2.32 C4.71,1.85 4.17,1.61 3.47,1.61 C2.84,1.61 2.29,1.83 1.83,2.28 C1.37,2.72 1.14,3.3 1.14,4.01 C1.14,4.72 1.37,5.3 1.83,5.74 C2.29,6.18 2.84,6.41 3.47,6.41 C4.14,6.41 4.7,6.19 5.15,5.74 C5.44,5.45 5.61,5.04 5.65,4.52 L3.47,4.52 L3.47,3.8 L6.38,3.8 C6.4,3.95 6.42,4.1 6.42,4.24 Z"
                      id="Path"
                    ></path>
                    <polygon
                      id="Path"
                      points="11.03 1.74 8.3 1.74 8.3 3.64 10.76 3.64 10.76 4.36 8.3 4.36 8.3 6.26 11.03 6.26 11.03 7 7.53 7 7.53 1 11.03 1 11.03 1.74"
                    ></polygon>
                    <polygon
                      id="Path"
                      points="14.28 7 13.51 7 13.51 1.74 11.83 1.74 11.83 1 15.95 1 15.95 1.74 14.27 1.74 14.27 7"
                    ></polygon>
                    <polygon
                      id="Path"
                      points="18.94 7 18.94 1 19.71 1 19.71 7"
                    ></polygon>
                    <polygon
                      id="Path"
                      points="23.13 7 22.36 7 22.36 1.74 20.68 1.74 20.68 1 24.8 1 24.8 1.74 23.12 1.74 23.12 7"
                    ></polygon>
                    <path
                      d="M32.61,6.22 C32.02,6.83 31.29,7.13 30.41,7.13 C29.53,7.13 28.8,6.83 28.21,6.22 C27.62,5.61 27.33,4.87 27.33,4 C27.33,3.13 27.62,2.38 28.21,1.78 C28.8,1.17 29.53,0.87 30.41,0.87 C31.28,0.87 32.01,1.17 32.61,1.78 C33.2,2.39 33.5,3.13 33.5,4 C33.49,4.88 33.2,5.62 32.61,6.22 Z M28.78,5.72 C29.22,6.17 29.77,6.39 30.41,6.39 C31.05,6.39 31.6,6.17 32.04,5.72 C32.48,5.27 32.71,4.7 32.71,4 C32.71,3.3 32.49,2.73 32.04,2.28 C31.6,1.83 31.05,1.61 30.41,1.61 C29.77,1.61 29.22,1.83 28.78,2.28 C28.34,2.73 28.11,3.3 28.11,4 C28.11,4.7 28.34,5.27 28.78,5.72 Z"
                      id="Shape"
                    ></path>
                    <polygon
                      id="Path"
                      points="34.58 7 34.58 1 35.52 1 38.44 5.67 38.47 5.67 38.44 4.51 38.44 1 39.21 1 39.21 7 38.41 7 35.36 2.11 35.33 2.11 35.36 3.27 35.36 7"
                    ></polygon>
                  </g>
                  <path
                    d="M68.14,21.75 C65.79,21.75 63.87,23.54 63.87,26 C63.87,28.45 65.79,30.25 68.14,30.25 C70.49,30.25 72.41,28.45 72.41,26 C72.41,23.54 70.49,21.75 68.14,21.75 Z M68.14,28.58 C66.85,28.58 65.74,27.52 65.74,26 C65.74,24.47 66.85,23.42 68.14,23.42 C69.43,23.42 70.54,24.47 70.54,26 C70.54,27.52 69.42,28.58 68.14,28.58 Z M58.82,21.75 C56.47,21.75 54.55,23.54 54.55,26 C54.55,28.45 56.47,30.25 58.82,30.25 C61.17,30.25 63.09,28.45 63.09,26 C63.09,23.54 61.17,21.75 58.82,21.75 Z M58.82,28.58 C57.53,28.58 56.42,27.52 56.42,26 C56.42,24.47 57.53,23.42 58.82,23.42 C60.11,23.42 61.22,24.47 61.22,26 C61.22,27.52 60.11,28.58 58.82,28.58 Z M47.74,23.06 L47.74,24.86 L52.06,24.86 C51.93,25.87 51.59,26.62 51.08,27.13 C50.45,27.76 49.47,28.45 47.75,28.45 C45.09,28.45 43.01,26.31 43.01,23.65 C43.01,20.99 45.09,18.85 47.75,18.85 C49.18,18.85 50.23,19.41 51,20.14 L52.27,18.87 C51.19,17.84 49.76,17.05 47.74,17.05 C44.1,17.05 41.04,20.01 41.04,23.66 C41.04,27.3 44.1,30.27 47.74,30.27 C49.71,30.27 51.19,29.63 52.35,28.42 C53.54,27.23 53.91,25.55 53.91,24.2 C53.91,23.78 53.88,23.39 53.81,23.07 L47.74,23.07 L47.74,23.06 Z M93.05,24.46 C92.7,23.51 91.62,21.75 89.41,21.75 C87.22,21.75 85.4,23.47 85.4,26 C85.4,28.38 87.2,30.25 89.62,30.25 C91.57,30.25 92.7,29.06 93.16,28.37 L91.71,27.4 C91.23,28.11 90.57,28.58 89.62,28.58 C88.67,28.58 87.99,28.14 87.56,27.29 L93.25,24.94 L93.05,24.46 Z M87.25,25.88 C87.2,24.24 88.52,23.4 89.47,23.4 C90.21,23.4 90.84,23.77 91.05,24.3 L87.25,25.88 Z M82.63,30 L84.5,30 L84.5,17.5 L82.63,17.5 L82.63,30 Z M79.57,22.7 L79.5,22.7 C79.08,22.2 78.28,21.75 77.26,21.75 C75.13,21.75 73.18,23.62 73.18,26.02 C73.18,28.4 75.13,30.26 77.26,30.26 C78.27,30.26 79.08,29.81 79.5,29.29 L79.56,29.29 L79.56,29.9 C79.56,31.53 78.69,32.4 77.29,32.4 C76.15,32.4 75.44,31.58 75.15,30.89 L73.52,31.57 C73.99,32.7 75.23,34.08 77.29,34.08 C79.48,34.08 81.33,32.79 81.33,29.65 L81.33,22.01 L79.56,22.01 L79.56,22.7 L79.57,22.7 Z M77.42,28.58 C76.13,28.58 75.05,27.5 75.05,26.02 C75.05,24.52 76.13,23.43 77.42,23.43 C78.69,23.43 79.69,24.53 79.69,26.02 C79.7,27.5 78.7,28.58 77.42,28.58 Z M101.81,17.5 L97.34,17.5 L97.34,30 L99.21,30 L99.21,25.26 L101.82,25.26 C103.89,25.26 105.92,23.76 105.92,21.38 C105.92,19 103.87,17.5 101.81,17.5 Z M101.85,23.52 L99.2,23.52 L99.2,19.23 L101.85,19.23 C103.25,19.23 104.04,20.39 104.04,21.37 C104.04,22.35 103.25,23.52 101.85,23.52 Z M113.39,21.73 C112.04,21.73 110.64,22.33 110.06,23.64 L111.72,24.33 C112.07,23.64 112.73,23.41 113.42,23.41 C114.38,23.41 115.37,23.99 115.38,25.02 L115.38,25.15 C115.04,24.96 114.32,24.67 113.43,24.67 C111.64,24.67 109.83,25.65 109.83,27.48 C109.83,29.15 111.29,30.23 112.93,30.23 C114.18,30.23 114.88,29.67 115.31,29.01 L115.37,29.01 L115.37,29.98 L117.170045,29.98 L117.170045,25.19 C117.18,22.97 115.52,21.73 113.39,21.73 Z M113.16,28.58 C112.55,28.58 111.7,28.27 111.7,27.52 C111.7,26.56 112.76,26.19 113.68,26.19 C114.5,26.19 114.89,26.37 115.38,26.61 C115.24,27.76 114.24,28.58 113.16,28.58 Z M123.74,22 L121.6,27.42 L121.54,27.42 L119.32,22 L117.31,22 L120.64,29.58 L118.74,33.79 L120.69,33.79 L125.82,22 L123.74,22 Z M106.94,30 L108.81,30 L108.81,17.5 L106.94,17.5 L106.94,30 Z"
                    id="Shape"
                    fill="#FFFFFF"
                  ></path>
                  <g id="Group" transform="translate(9.000000, 7.000000)">
                    <path
                      d="M1.44,0.54 C1.15,0.85 0.98,1.33 0.98,1.94 L0.98,24.06 C0.98,24.68 1.15,25.16 1.44,25.46 L1.51,25.53 L13.9,13.15 L13.9,13 L13.9,12.85 L1.51,0.47 L1.44,0.54 Z"
                      id="Path"
                      fill="url(#linearGradient-1)"
                    ></path>
                    <path
                      d="M18.03,17.28 L13.9,13.15 L13.9,13 L13.9,12.85 L18.03,8.72 L18.12,8.77 L23.01,11.55 C24.41,12.34 24.41,13.64 23.01,14.44 L18.12,17.22 L18.03,17.28 Z"
                      id="Path"
                      fill="url(#linearGradient-2)"
                    ></path>
                    <path
                      d="M18.12,17.22 L13.9,13 L1.44,25.46 C1.9,25.95 2.66,26.01 3.52,25.52 L18.12,17.22"
                      id="Path"
                      fill="url(#linearGradient-3)"
                    ></path>
                    <path
                      d="M18.12,8.78 L3.51,0.48 C2.65,-0.01 1.89,0.05 1.43,0.54 L13.9,13 L18.12,8.78 Z"
                      id="Path"
                      fill="url(#linearGradient-4)"
                    ></path>
                    <g
                      transform="translate(0.000000, 17.000000)"
                      fill="#000000"
                      id="Path"
                    >
                      <path
                        d="M18.03,0.13 L3.51,8.38 C2.7,8.84 1.97,8.81 1.51,8.39 L1.51,8.39 L1.44,8.46 L1.44,8.46 L1.51,8.53 L1.51,8.53 C1.98,8.95 2.7,8.98 3.51,8.52 L18.12,0.22 L18.03,0.13 Z"
                        opacity="0.2"
                      ></path>
                      <path
                        d="M1.44,8.32 C1.15,8.01 0.98,7.53 0.98,6.92 L0.98,7.07 C0.98,7.69 1.15,8.17 1.44,8.47 L1.51,8.4 L1.44,8.32 Z"
                        opacity="0.12"
                      ></path>
                    </g>
                    <path
                      d="M23.01,14.3 L18.02,17.13 L18.11,17.22 L23,14.44 C23.7,14.04 24.05,13.52 24.05,13 L24.05,13 C24,13.47 23.65,13.94 23.01,14.3 Z"
                      id="Path"
                      fill="#000000"
                      opacity="0.12"
                    ></path>
                    <path
                      d="M3.51,0.62 L23.01,11.7 C23.64,12.06 24,12.52 24.06,13 L24.06,13 C24.06,12.48 23.71,11.95 23.01,11.56 L3.51,0.48 C2.11,-0.31 0.97,0.35 0.97,1.95 L0.97,2.1 C0.97,0.49 2.12,-0.17 3.51,0.62 Z"
                      id="Path"
                      fill="#FFFFFF"
                      opacity="0.25"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </a>
);

export default GooglePlayButton;
